import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { TravellerDataTranslationService } from "libraries/service/traveller-data-translation/traveller-data-translation.service";
import { LabelService } from "libraries/service/label/label.service";
import { Yii } from "libraries/interfaces/Yii";
import { TravellerXTitle } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { DateMomentPipe } from "libraries/date/dateMoment.pipe";
import { IWenji } from "libraries/interfaces/IWenji";

declare const wenji: IWenji;

@Component({
    selector: 'booking-traveller-abstract',
    template: `
        <article [class.inline]="isInline">
            <div>
                <strong>{{identity}}</strong>
                <div class="given-name" *ngIf="givenName">{{givenName}}</div>
            </div>
            <div class="type">{{type}}</div>
            <div *ngIf="traveller.birthDate">{{born}} {{age}}</div>
        </article>
    `,
    styles: [`
        article.inline {
            display: flex;
        }
        div {
            margin: .75rem;
        }

        div div {
            margin: auto;
        }

        .type:first-letter {
            text-transform: capitalize;
        }
    `]
})

export class BookingTravellerAbstractComponent implements OnChanges {
    @Input()
    public readonly traveller: ITraveller;

    @Input()
    public ageDate: string;

    @Input()
    public isInline: boolean;

    public identity: string = "";
    public type: string = "";
    public age: string;
    public born: string;
    public givenName: string;

    constructor(
        private travellerDataTranslationService: TravellerDataTranslationService,
        private labelService: LabelService,
        private dateMomentPipe: DateMomentPipe) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.traveller && changes.traveller.currentValue) {
            const traveller: ITraveller = changes.traveller.currentValue;
            this.identity = this.travellerDataTranslationService.getTravellerIdentity(traveller);
            this.type = this.travellerDataTranslationService.translateType(traveller.xType);

            const gender: string = traveller.xGender ?
                traveller.xGender :
                traveller.xTitle === TravellerXTitle.ms ?
                    "female" :
                    "male";

            const bornString: string = gender === "female" ?
                Yii.t('wui-shared-js', 'Née le %placeholder%') :
                Yii.t('wui-shared-js', 'Né le %placeholder%');

            if (traveller.birthDate) {
                this.age = `(${this.travellerDataTranslationService.getTravellerAge(traveller, this.ageDate)})`;
                this.born = this.labelService.completeLabel(
                    bornString,
                    this.dateMomentPipe.transform(traveller.birthDate, JSON.parse(wenji.ui.dateFormat).momentShort),
                );
            }

            if (traveller.givenName) {
                this.givenName = this.travellerDataTranslationService.getGivenName(traveller.givenName);
            }

        }
    }
}